import { render, staticRenderFns } from "./ModalCollection.vue?vue&type=template&id=3de72946&"
import script from "./ModalCollection.vue?vue&type=script&lang=js&"
export * from "./ModalCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports